export default __webpack_public_path__ + "static/media/LogoBirds.4c6fa939.png";